import { render } from "./EditFiltersButton.vue?vue&type=template&id=5c78c58d&scoped=true"
import script from "./EditFiltersButton.vue?vue&type=script&lang=js"
export * from "./EditFiltersButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c78c58d"]])

export default __exports__